// extracted by mini-css-extract-plugin
export var heroImage = "_ew-1";
export var modal = "_ew-0";